import React from 'react';
import Resource from '../../../../common/Resource'
import Panel from '../../../../common/layout/Panel'

export default class extends React.Component {
    getObjectProps(id) {
        const data = this.props.parent;
        let name = '';
        let service_type = '';
        data && data.data.map((item, i) => {
            if (item['rate_id'] === id) {
                name = item['name'];
                service_type = item['service_type'];
            }
        });
        return {'name': name, 'service_type': service_type};
    }
    render () {
        const rate_id = this.props.match.params.rate_id;
        const data = {
            url: `/admin/products/mms/rates/${rate_id}/items`,
            data: {
                data: [],
                metadata: []
            },
            name: '',
            metadata:
                [
                    {
                        label: 'id',
                        source: 'mms_rateitem_id',
                        type: 'primary',
                        editable: false,
                        visible: false
                    },
                    {
                        label: 'Destination',
                        source: 'DESTINATION',
                        type_edit: 'text',
                        type_add: 'select',
                        editable: false,
                        visible: true,
                        default : {
                            'type': 'uri',
                            'data': `/admin/products/mms/rates/${rate_id}/available_codes`,
                            'params': {}
                        },
                        placeholder: 'Select...'
                    },
                    {
                        label: 'Rate',
                        source: 'rate',
                        type: 'text',
                        editable: true,
                        visible: true,
                        placeholder: '0.00'
                    },
                    {
                        label: 'Currency',
                        source: 'currency_id',
                        type: 'select',
                        editable: true,
                        visible: true,
                        placeholder: 'USD',
                        default: 1
                    },
                    {
                        label: 'Enabled',
                        source: 'status',
                        type: 'checkbox',
                        editable: true,
                        visible: true,
                        default: true
                    },
                    {
                        'label' : 'Actions',
                        'type': 'action_buttons'
                    }
                ]
        }
        let obj_props = this.getObjectProps(rate_id);
        let label = {label: 'MMS', className: 'label-warning'};

        const title = "MMS Rate Table: " + obj_props.name;

        return (
            <Panel title = {title} label = {label}>
                <Resource
                    addButtonText = "Add MMS Rate Item"
                    data = {data}
                    {...this.props}
                />
            </Panel>
        )
    }
}
